<template>
  <div class="col-12 row">
    <div class="col-12 text-h6 text-left">
      {{ sessionNoteField.label }}
    </div>
    <div
      v-if="sessionNoteField.hint"
      class="col-12 text-subtitle1 text-left q-py-md"
    >
      {{ sessionNoteField.hint }}
    </div>
    <div class="col-12">
      <div
        v-if="isLoading"
        class="row q-col-gutter-sm q-mt-md"
      >
        <div
          v-for="n in 5"
          :key="n"
          class="row col-12 items-center"
        >
          <div class="col-auto q-mr-md">
            <q-skeleton
              type="QCheckbox"
            />
          </div>
          <div>
            <q-skeleton
              type="text"
              width="250px"
            />
          </div>
        </div>
      </div>
      <div
        v-else
        class="text-left q-mt-md"
      >
        <q-option-group
          :model-value="formatSelectValue(sessionNoteField.value)"
          type="checkbox"
          :options="options"
          :disable="disabledFields"
          class="text-left"
          @update:model-value="onSelectOption"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Toolbox from 'src/mixins/Toolbox';

export default {
  name: 'SessionNoteProgramFieldForm',

  mixins: [Toolbox],

  props: {
    sessionNoteField: {
      type: Object,
      required: true,
    },
    session: {
      type: Object,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    disabledFields: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['select-option'],

  data() {
    return {
      isLoading: false,

      inputValue: '',
    };
  },

  methods: {

    onSelectOption(selectedOptions) {
      const sortedOptions = Array.isArray(selectedOptions)
        ? selectedOptions.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
        : [];
      this.$emit('select-option', sortedOptions);
    }, // onSelectOption()

    formatSelectValue(value) {
      return Array.isArray(value) ? value : [];
    }, // formatSelectOptions()

  },
};
</script>
